import React from 'react';

export const Main = () => {
    return (
        <div>
            &nbsp;.
        </div>
    )
}